import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=754ae4e0&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PermissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=754ae4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ae4e0",
  null
  
)

export default component.exports